<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
<div class="container">
  <div class="row" *ngIf="myadoption && myadoption.length > 0; else noadoption">
      <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3"  *ngFor="let animal of myadoption ">
          <div class="card" style="margin-top: 3%">
              <img class="card-img-top" style="width:100%; max-height:150px" src="https://passport.petcart.in/images/adoption/{{animal.photo}}" alt="Card image">
          </div>
          <div class="card-body">
            <p class="card-text">
                I am waiting for a home  Anyone Who wants to adopt me  as a child please Click the  button below.
            </p>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-sm-12  text-center">
                <button class="btn btn-success btn-block" routerLink="/petadoption/knowme/{{animal.id}}/manageprofile" >
                <span >Manage Request  </span>
                </button>
                </div>
            </div>
          </div>
         </div>
  </div>
</div>
<ng-template #noadoption>
  <div class="card" *ngIf="found == 0 && myadoption.length === 0">
      <div class="row">
          <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6 text-center">
            <h5 style="color: #9b7544; font-style: open sans"><span>
            No Adoption Request posted from your account!
          </span></h5>
          </div>
          <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6 text-center">
              <button class="btn btn-secondary btn-block" routerLink="/petadoption/formfillup">Create Adoption Request</button>
            </div>
        </div>
  </div>

</ng-template>
